
import React from "react";
import { Button } from "@/components/ui/button";
import { Copy, Download, Send, CheckCircle2, Save } from "lucide-react";

interface EmailActionButtonsProps {
  generatedEmail: string;
  emailSent: boolean;
  isSending: boolean;
  onSaveAsDraft: () => void;
  onCopyToClipboard: () => void;
  onDownload: () => void;
  onSendEmail: () => void;
}

const EmailActionButtons = ({
  generatedEmail,
  emailSent,
  isSending,
  onSaveAsDraft,
  onCopyToClipboard,
  onDownload,
  onSendEmail
}: EmailActionButtonsProps) => {
  if (!generatedEmail) return null;
  
  return (
    <div className="flex space-x-2">
      <Button 
        variant="outline" 
        size="sm"
        onClick={onSaveAsDraft}
      >
        <Save className="h-4 w-4 mr-1" /> Save
      </Button>
      <Button 
        variant="outline" 
        size="sm"
        onClick={onCopyToClipboard}
      >
        <Copy className="h-4 w-4 mr-1" /> Copy
      </Button>
      <Button 
        variant="outline" 
        size="sm"
        onClick={onDownload}
      >
        <Download className="h-4 w-4 mr-1" /> Download
      </Button>
      {!emailSent && (
        <Button 
          variant="default" 
          size="sm"
          onClick={onSendEmail}
          disabled={isSending}
          className="bg-green-600 hover:bg-green-700"
        >
          {isSending ? 
            "Processing..." : 
            <><Send className="h-4 w-4 mr-1" /> Mark as Sent</>
          }
        </Button>
      )}
      {emailSent && (
        <Button 
          variant="outline" 
          size="sm"
          className="text-green-600 border-green-600"
          disabled
        >
          <CheckCircle2 className="h-4 w-4 mr-1" /> Email Marked as Sent
        </Button>
      )}
    </div>
  );
};

export default EmailActionButtons;
